import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Dropdown, Card } from "react-bootstrap";
import { FaUserFriends } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "./MySkills.css";
import Navbar from "../../../Pages/Navbar/JobSeekerNavbar";
import Swal from 'sweetalert2';
import BaseUrl from '../../../ApiServices/BaseUrl';
import { HOSPITALITY_POSITIONS, SOFTWARE_IT_POSITIONS, CONSTRUCTION_POSITIONS, RETAIL_SALES_POSITIONS, CLEANING_MAINTENANCE_POSITIONS } from '../../../../Constants/dropdownOptions';

function MySkills() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userId = location.state?.userId || user.id || '';
  const current_country = location.state?.current_country || '';
  const { state } = useLocation();
  const { job_position } = state || {};

  // Language options - first 8 in buttons, rest in dropdown
  const generalLanguagesMain = [
    "English", "Arabic", "Hindi", "Srilankan"
  ];
  const generalLanguagesAdditional = [
    "Russian", "Bangali", "Cantonese", "Vietnamese",
    "Indonesia (Bahasa)", "Combodian", "Iranian", "Filipino (Tagalog)"
  ];

  const englishLevels = ["Fluent", "Fair", "Poor", "Very Poor"];
  const literacyOptions = ["Read", "Write", "No Read", "No Write"];
  const skinColorOptions = ["Very Fair", "Fair", "Medium", "Dark"]; // Renamed from colorOptions

const cncPositions = [
  "CNC Machinist",
  "CNC Programmer",
  "CNC Milling Programmer",
  "CNC Turning Programmer",
  "CNC 5-Axis Programmer",
  "CNC CAD/CAM Programmer",
  "CNC Setter",
  "CNC Setup Operator",
  "CNC Quality Inspector (CMM)",
  "CNC Maintenance Technician",
  "CNC Tool Room Technician",
  "CNC Production Technician",
  "CNC Machine Operator",
  "CNC Milling Operator",
  "CNC Turning Operator",
  "CNC Lathe Operator",
  "CNC VMC Operator",
  "CNC HMC Operator"
];

  const companyWorkerSkills = [
    "Salesman",
    "Sales Executive",
    "Senior Sales Executive",
    "Outdoor Salesman",
    "Indoor Salesman",
    "Business Development Executive",
    "Marketing Executive",
    "Digital Marketing Executive",
    "Tele-Sales Executive",
    "Account Manager (Sales)",
    "Receptionist",
    "Front Desk Executive",
    "Office Assistant",
    "Office Boy",
    "Office Helper",
    "Admin Assistant",
    "Customer Support Executive",
    "Call Center Agent",
    "Admin Executive",
    "Office Administrator",
    "Operations Executive",
    "Document Controller",
    "Data Entry Operator",
    "HR Assistant",
    "HR Executive",
    "Accountant",
    "Assistant Accountant",
    "Accounts Executive",
    "Cashier",
    "Billing Executive",
    "Payroll Executive",
    "Back Office Executive",
    "Office Coordinator",
    "Project Coordinator",
    "Logistics Coordinator",
    "Sales Coordinator",
    "Office Manager",
    "Operations Manager",
    "Admin Manager",
    "Sales Manager"
  ];
  const jobPositionOptions = [
    "Home Driver", "Home Cook", "Home Care Nurse", "Cleaner", "Home Caregiver", "Nanny", "Baby Sitter", "Elderly Care", "Company Driver", "Motorbike Driver", "Domestic Helper", "Maid", "Beautician", "Driver", "Driver (Company / House)", "Lady Driver", "Personal Driver", "Bus Driver", "Plumber", "Taxi Driver", "Operator", "Electrician", "Welder", "6G Certified Pipe Welder", "6G TIG + SMAW Pipe Welder", "6G / 6GR Pipe Welder", "High Pressure 6G Pipe Welder", "ASME 6G Pipe Welder", "6G Oil & Gas Pipe Welder", "Cook", "Cook (Company / House)", "Nanny", "Nurse", "Houseboy", "Tailor", "Teacher", "Trainer", "Gardener", "Farmar", "Butler", "Housekeeper", "Laundry Worker", "Personal Assistant", "Caregiver", "Elder Care", "Pet Sitter", "House Manager", "Maintenance Worker", "Baby Sitter", "Tutor", "Chauffeur", "Housemaid", "Kitchen Staff", "Dining Room Attendant", "Personal Chef", "Event Coordinator", "Household Administrator", "Domestic Assistant", "Hospital Nurse", "Hospital Doctor", "Resident Doctor", "Heavy Driver", "Bike Driver", "Workers", "Skilled Workers", "Construction Workers", "Skilled Construction Workers", "Mason", "Carpenter", "Steel Fixer", "Painter", "AC Technician", "HVAC Technician", "Chiller Technician", "Lathe & Milling Machine", "Lathe Machine Operator", "Milling Machine Operator", "Heavy Equipment Operator", "Scaffolder", "Healthcare Assistants", "Doctors", "Lab Technicians", "Physiotherapists", "Elderly Care Workers", ...HOSPITALITY_POSITIONS, ...SOFTWARE_IT_POSITIONS, ...CONSTRUCTION_POSITIONS, ...RETAIL_SALES_POSITIONS, ...CLEANING_MAINTENANCE_POSITIONS, "Factory Workers", "Production Workers", "Warehouse Workers", "Packing Staff", "Machine Operators", "Assembly Line Workers", "Forklift Operators", "Delivery Drivers", "Truck Drivers", "Logistics Staff", "Farm Workers", "Fruit Pickers", "Dairy Workers", "Poultry Workers", "Greenhouse Workers", "Caretakers", "Private Drivers", "JCB Operator", "Bulldozer Operator", "Excavator Operator", "Loader Operator", "Skid Steer Loader Operator", "Grader Operator", "Trench Excavator / Trencher Operator", "Backhoe Operator", "Dragline Operator", "Scraper Operator", "Crane Operator", "Telehandler Operator", "Reach Stacker Operator", "Boom Lift / Cherry Picker Operator", "Container Handler Operator", "Road Roller Operator", "Asphalt Paver Operator", "Bitumen Sprayer Operator", "Concrete Paver Operator", "Soil Stabilizer Operator", "Drilling Machine / Drill Rig Operator", "Rock Breaker / Hydraulic Hammer Operator", "Loader-Dumper Operator", "Dump Truck Operator", "Stone Crusher Operator", "Grizzly Feeder / Conveyor Operator", "Tractor Operator", "Harvester / Combine Operator", "Dozer / Land Leveling Operator", "Tower Crane Operator", "Mobile Crane Operator", "Crawler Crane Operator", "Piling Machine Operator", "Concrete Mixer Truck Operator", "Concrete Pump Operator", "Compactor Operator", "Pipe Layer Operator", "Forklift / Warehouse Equipment Operator", "Boom Truck / Loader Crane Operator", "Road Sweeper Operator", "Water Tanker / Firefighting Vehicle Operator", "Excavator Mounted Drill Operator", "Heavy Truck / Tip Truck Operator", "Loader Excavator Operator", "Teleporter Crane Operator", "Material Handler / Port Crane Operator", "Hydraulic Excavator Operator", "Multi-Functional Heavy M",
    ...cncPositions,
    "CNC Operator", "CNC Programmer", "Machine Operator", "Assembly Line Worker", "Production Worker", "MIG Welder", "TIG Welder", "Industrial Welder", "Fabricator", "Pipe Fitter", "Steel Structure Welder", "Heavy Truck Mechanic", "Diesel Mechanic", "Auto Mechanic", "Bus Mechanic", "Vehicle Technician", "Industrial Electrician", "Maintenance Electrician", "Panel Electrician", "Maintenance Technician", "Electrical Technician", "PLC Technician", "Automation Technician", "Construction Worker", "Warehouse Worker", "Forklift Operator", "Picker & Packer", "Delivery Van Driver", "Logistics Assistant", "Heavy Truck Driver (CE)", "Trailer Driver", "Chef", "Kitchen Assistant", "Hotel Housekeeping", "Medical Technician", "Instrument Technician", "Mechanical Maintenance Technician", "Heavy Equipment Mechanic", "6G Welder", "Structural Welder", "Shipyard Welder", "FCAW Welder (Shipyard)", "MIG/MAG Welder (Shipyard)", "TIG Welder (Shipyard)", "6G Pipe Welder (Shipyard)", "Heavy Trailer Driver", "Fuel Tanker Driver", "Ready-Mix Driver", "Registered Nurse", "Professional Chef", "Any Nurse", "Clinic / Shop Nurse", "School Nurse", "Company / Industrial Nurse", "Special Care Nurse", "Emergency / Ambulance Nurse", "Lab / Assistant Nurse", "Hotel / Resort Nurse", "General Physician", "Specialist Doctor", "Consultant Doctor", "Surgeon", "Pediatrician", "Gynecologist", "Orthopedic Doctor", "Cardiologist", "Neurologist", "Dermatologist", "ENT Specialist", "Ophthalmologist (Eye Doctor)", "Anesthesiologist", "Radiologist", "Psychiatrist", "Emergency Doctor", "ICU Doctor", "Family Medicine Doctor", "Dental Doctor", "Medical Officer", "Home Nurse", "Elevator Technician", "Elevator Installation Technician", "Elevator Maintenance Technician", "Elevator Repair Technician", "Escalator Technician",
    ...companyWorkerSkills
  ];
  const companyWorkerSkillsSet = new Set(companyWorkerSkills.map(skill => skill.toLowerCase()));
  const getCompanyWorkerSkillsFromPositions = (positions) => {
    const list = Array.isArray(positions) ? positions : (positions ? [positions] : []);
    return list
      .filter(pos => companyWorkerSkillsSet.has(String(pos).toLowerCase()))
      .map(pos => companyWorkerSkills.find(skill => skill.toLowerCase() === String(pos).toLowerCase()) || pos);
  };
  const buildMainSkillsFromJobPositions = (positions) => {
    const list = Array.isArray(positions) ? positions : (positions ? [positions] : []);
    if (list.length === 0) return [];
    const lowerPositions = list.map(pos => String(pos).toLowerCase());
    const has = (value) => lowerPositions.some(pos => pos.includes(value));
    return Array.from(new Set([
      ...(has("driver") ? ["Driving"] : []),
      ...(has("cook") ? ["Cooking"] : []),
      ...(has("cnc operator") || has("cnc machine") ? ["CNC Operator"] : []),
      ...(has("cnc programmer") ? ["CNC Programmer"] : []),
      ...(has("mechanic") ? ["Mechanic"] : []),
      ...(has("welder") ? ["Welding"] : []),
      ...(has("electrician") ? ["Electrician"] : []),
      ...(has("fabricator") ? ["Fabricator"] : []),
      ...(has("pipe fitter") ? ["Pipe Fitter"] : []),
      ...(has("ac technician") ? ["AC Technician"] : []),
      ...(has("hvac technician") ? ["HVAC Technician"] : []),
      ...(has("chiller technician") ? ["Chiller Technician"] : []),
      ...(has("lathe") || has("milling machine") ? ["Machine Operator"] : []),
      ...(has("elevator") || has("escalator") ? ["Elevator Technician"] : []),
      ...getCompanyWorkerSkillsFromPositions(positions),
      ...list
    ]));
  };

  // Main Skills options - first 8 in buttons, rest in dropdown
  const mainSkillsMain = [
    // Existing skills
    "Baby care", "Child care", "Teen care", "Elderly care",
    "Pets care", "Tutoring", "Housekeeping", "Cooking", "Marketing", "Groceries", "Teaching",

    // Teacher specific skills
    "Lesson Planning", "Curriculum Development", "Classroom Management",
    "Student Assessment", "Educational Technology", "Differentiated Instruction",
    "Special Education", "Parent Communication", "Student Counseling",
    "Educational Research", "Test Preparation", "Academic Advising",
    "Educational Leadership", "Workshop Facilitation", "Pedagogical Training",

    // Doctor specific skills
    "Patient Diagnosis", "Medical Consultation", "Treatment Planning",
    "Surgical Procedures", "Medical Research", "Clinical Expertise",
    "Emergency Medicine", "Medical Documentation", "Patient Education",
    "Disease Management", "Medical Ethics", "Healthcare Management",
    "Medical Imaging Interpretation", "Laboratory Analysis", "Pharmaceutical Knowledge",

    // Nurse specific skills
    "Patient Assessment", "Medication Administration", "Wound Care",
    "IV Therapy", "Patient Monitoring", "Nursing Documentation",
    "Emergency Response", "Patient Advocacy", "Health Education",
    "Infection Control", "Patient Safety", "Care Planning",
    "Vital Signs Monitoring", "Medical Equipment Operation", "Rehabilitation Care", "Rehabilitation Therapy",
    "Pain Management", "Manual Therapy", "Electrotherapy", "Exercise Therapy",
    "Post-Surgery Rehab", "ICU Rehab", "House Nurse",

    // Beautician specific skills
    "Hair Styling", "Hair Coloring", "Hair Cutting",
    "Makeup Application", "Facial Treatments", "Skin Care Analysis",
    "Nail Art", "Manicure & Pedicure", "Waxing Services",
    "Bridal Makeup", "Spa Treatments", "Lash & Brow Services",
    "Beauty Consultation", "Product Knowledge", "Color Analysis",

    // Tailor specific skills
    "Pattern Making", "Garment Cutting", "Sewing",
    "Alterations", "Fitting", "Embroidery",
    "Stitching", "Fabric Selection", "Measurements",
    "Designing", "Dressmaking", "Tailoring",
    "Mending", "Custom Fitting", "Hand Stitching",
    "Machine Operation", "Fabric Knowledge", "Quality Control",
    "Creative Designing", "Fashion Trends", "Material Estimation",

    // General professional skills
    "Communication Skills", "Time Management", "Problem Solving",
    "Team Collaboration", "Adaptability", "Critical Thinking",
    "Attention to Detail", "Multitasking", "Leadership",
    "Technical Skills", "Creative Thinking", "Analytical Skills",

    // Driver specific skills (NEWLY ADDED)
    "Car Cleaning", "Vehicle Maintenance", "Fuel Management",
    "Errand Running", "Bill Payments", "Shopping Assistance",
    "Document Delivery", "Household Support", "Gate Duty",
    "Parking Management", "Vehicle Records", "Basic Repairs",
    'Operator',
    'Bus Driver',
    'Taxi Driver',
    "Bike Driver",
    "Car delivery Driver",
    "Motor bike Driver",
    "Light Driver",
    "Heavy Driver",
    "Driver",
    "Car Driver",
    'Plumber',
    'Electrician',
    'Welding',
    'Fabricator',
    'Pipe Fitter',
    'AC Technician',
    'HVAC Technician',
    'Chiller Technician',
    'Machine Operator',

    // CNC & General Missing
    "CNC Operator",
    "CNC Programmer",
    "Driving",
    "Mechanic",
  ];
  const mainSkillsAdditional = [
    ...jobPositionOptions,
    "Nursing License"
  ];

  // Cooking Skills options - first 8 in buttons, rest in dropdown
  const cookingSkillsMain = [
    "Arabic", "Indian", "Italian", "Japanese", "Chinese", "Thai",
    "Singaporean", "Vegeterian"
  ];
  const cookingSkillsAdditional = [
    "Western", "French", "Mexican", "Turkey", "Moroccan", "Brazilian",
    "Lebanese", "Spain", "Greece", "United States", "Korean", "Peruvian"
  ];

  // Other Skills options - first 8 in buttons, rest in dropdown
  const otherSkillsMain = [
    "Baking", "Caregiver", "Car wash", "Computer", "Cleaning", "Sweet", "Tandur Roti", "Salad"
  ];
  const otherSkillsAdditional = [
    "Driving Lic.", "Firstaid", "Gardening", "Handiman", "Housework", "Sewing", "Swimming", "Laundry",
    "Cooking", "Washing", "Mopping", "Sweeping", "Childcare",
    "Dishwashing", "Organizing", "Shopping", "Ironing", "Dusting", "Babysitting", "Nursing License"
  ].filter(item => !otherSkillsMain.includes(item) && !mainSkillsMain.includes(item) && !mainSkillsAdditional.includes(item));

  // Personality Traits options - first 8 in buttons, rest in dropdown
  const personalityTraitsMain = [
    "Hard working", "Good listener", "Pet lover", "Independent", "Honest",
    "Kids lover", "Love cooking", "Loyal"
  ];
  const personalityTraitsAdditional = [
    "Patience", "Trust worthy", "Strong", "Willing to Learn", "Self-managed"
  ];

  const otherLanguages = ["Thai", "Macanese", "Other", "Japanese", "German", "French", "Spanish", "Russian", "Bangali", "Cantonese", "Vietnamese",
    "Indonesia (Bahasa)", "Combodian", "Iranian", "Filipino (Tagalog)"];
  const heightOptions = ["152-154", "154-156", "156-157", "158-160", "160-162", "176 above"];
  const weightOptions = ["40-45", "45-50", "50-55", "55-60", "60-65", "85 above"];

  const [formData, setFormData] = useState({
    user_id: userId,
    language: [{ language: "English", speaking_level: "Fair", can_read: true, can_write: true }],
    height: '160-162',
    weight: '60-65',
    color: 'Medium', // This field is now optional
    main_skills: buildMainSkillsFromJobPositions(job_position),
    cooking_skills: job_position && Array.isArray(job_position) && job_position.some(pos => pos.toLowerCase().includes("cook")) ? ["Arabic"] : ["Indian"],
    other_skills: (() => {
      const isCookPos = job_position && Array.isArray(job_position) && job_position.some(pos => pos.toLowerCase().includes("cook"));
      const isDriverPos = job_position && Array.isArray(job_position) && job_position.some(pos => pos.toLowerCase().includes("driver"));
      if (isCookPos) return ["Cleaning", "Sweet", "Tandur Roti", "Salad"];
      if (isDriverPos) return ["Car wash", "Cleaning"];
      return ["Cleaning"];
    })(),
    personality: ["Hard working", "Good listener", "Independent"],
    otherLanguage: '',
    otherCookingSkill: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const isNurse = (Array.isArray(formData.job_position)
    ? formData.job_position
    : formData.job_position ? [formData.job_position] : []
  ).some(pos => String(pos).toLowerCase().includes("nurse")) || (
    Array.isArray(job_position) ? job_position : job_position ? [job_position] : []
  ).some(pos => String(pos).toLowerCase().includes("nurse"));
  const isCompanyWorker = (Array.isArray(formData.job_position)
    ? formData.job_position
    : formData.job_position ? [formData.job_position] : []
  ).some(pos => companyWorkerSkillsSet.has(String(pos).toLowerCase())) || (
    Array.isArray(job_position) ? job_position : job_position ? [job_position] : []
  ).some(pos => companyWorkerSkillsSet.has(String(pos).toLowerCase()));
  const hideCookingAndOtherSkills = isNurse || isCompanyWorker;
  const isCook = job_position && Array.isArray(job_position) ? job_position.some(pos => pos.toLowerCase().includes("cook")) : (typeof job_position === 'string' && job_position.toLowerCase().includes("cook"));

  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = '',
    isMultiSelect = false,
    currentSelections = []
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    const getDisplayText = () => {
      if (isMultiSelect && currentSelections.length > 0) {
        // Show count of selected items for multi-select
        const selectedFromOptions = currentSelections.filter(item =>
          options.includes(item)
        );
        if (selectedFromOptions.length > 0) {
          return `${selectedFromOptions.length} selected`;
        }
      }
      return selectedValue || `${title}${required ? ' *' : ''}`;
    };

    const handleItemClick = (option) => {
      if (isMultiSelect) {
        // For multi-select, toggle the item
        toggleItem(field, option);
      } else {
        // For single select
        onSelect({ target: { name: field, value: option } });
      }
      setLocalSearchTerm('');
      setIsOpen(false);
    };

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
          >
            {getDisplayText()}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`} style={{ overflowY: 'hidden' }}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={isMultiSelect ? currentSelections.includes(option) : selectedValue === option}
                    onClick={() => handleItemClick(option)}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  const parseArrayField = (field) => {
    if (!field) return [];

    if (Array.isArray(field)) {
      return field.flatMap(item => {
        try {
          const parsed = typeof item === 'string' ? JSON.parse(item) : item;
          return Array.isArray(parsed) ? parsed : [parsed];
        } catch {
          return [item];
        }
      })
        .filter(item => item && item !== 'null' && item !== 'undefined')
        .map(item => item.trim())
        .filter((item, index, self) => self.indexOf(item) === index);
    }

    if (typeof field === 'string') {
      try {
        const parsed = JSON.parse(field);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [field];
      }
    }

    return [field];
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchJobSeekerData = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/job-seeker/${userId}`);
        if (response.ok) {
          const data = await response.json();

          if (data) {
            let languageData = [];
            if (data.language) {
              if (Array.isArray(data.language)) {
                languageData = data.language;
              } else if (typeof data.language === 'string') {
                try {
                  languageData = JSON.parse(data.language);
                  if (!Array.isArray(languageData)) {
                    languageData = [languageData];
                  }
                } catch {
                  languageData = [];
                }
              }
            }

            const mainSkillsData = parseArrayField(data.main_skills);
            const cookingSkillsData = parseArrayField(data.cooking_skills);
            const otherSkillsData = parseArrayField(data.other_skills);
            const personalityData = parseArrayField(data.personality);

            const selectedLanguages = languageData.map(lang => lang.language);
            const otherLanguage = selectedLanguages.find(lang => ![...generalLanguagesMain, ...generalLanguagesAdditional, ...otherLanguages].includes(lang)) || '';

            const formData = {
              user_id: userId,
              language: (languageData && languageData.length > 0) ? languageData : [{ language: "English", speaking_level: "Fair", can_read: true, can_write: true }],
              height: (data.height && data.height !== 'Not specified') ? data.height.replace(/\s*cm\s*/i, '') : '160-162',
              weight: (data.weight && data.weight !== 'Not specified') ? data.weight.replace(/\s*kg\s*/i, '') : '60-65',
              color: (data.color && data.color !== 'Not specified') ? data.color : 'Medium',
              main_skills: (() => {
                const derivedSkills = buildMainSkillsFromJobPositions(job_position);
                if (mainSkillsData && mainSkillsData.length > 0 && !mainSkillsData.includes('Not specified')) {
                  return Array.from(new Set([...mainSkillsData, ...derivedSkills]));
                }
                return derivedSkills;
              })(),
              cooking_skills: (() => {
                const base = (cookingSkillsData && cookingSkillsData.length > 0 && !cookingSkillsData.includes('Not specified')) ? cookingSkillsData : ["Indian"];
                if (isCook && !base.includes('Arabic')) return ['Arabic', ...base.filter(s => s !== 'Indian')];
                return base;
              })(),
              other_skills: (() => {
                let result = (otherSkillsData && otherSkillsData.length > 0 && !otherSkillsData.includes('Not specified')) ? [...otherSkillsData] : [];
                const isDriverPos = job_position && Array.isArray(job_position) && job_position.some(pos => pos.toLowerCase().includes('driver'));
                // For cooks: remove Car wash, force cook skills
                if (isCook) {
                  result = result.filter(s => s !== 'Car wash');
                  ['Cleaning', 'Sweet', 'Tandur Roti', 'Salad'].forEach(s => { if (!result.includes(s)) result.push(s); });
                } else {
                  if (!result.includes('Cleaning')) result.push('Cleaning');
                  if (isDriverPos && !result.includes('Car wash')) result.unshift('Car wash');
                }
                return result;
              })(),
              personality: (personalityData && personalityData.length > 0 && !personalityData.includes('Not specified')) ? personalityData : ["Hard working", "Good listener", "Independent"],
              otherLanguage: otherLanguage,
              otherCookingSkill: cookingSkillsData.find(skill => ![...cookingSkillsMain, ...cookingSkillsAdditional].includes(skill)) || ''
            };

            setFormData(formData);
            setIsSaved(true);
          }
        } else if (response.status === 404) {
          setIsSaved(false);
        } else {
          throw new Error('Failed to fetch job seeker data');
        }
      } catch (err) {
        console.error('Error fetching job seeker data:', err);
        await Swal.fire({
          title: 'Error!',
          text: err.message || 'Failed to load data. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      }
    };

    if (userId) {
      fetchJobSeekerData();
    }
  }, [userId]);

  const getSelectedLanguages = () => {
    return formData.language.map(lang => lang.language);
  };

  const getLanguageDetails = (language) => {
    const langData = formData.language.find(lang => lang.language === language);
    return langData || {
      language: language,
      speaking_level: language === "English" || language === "Arabic" ? '' : 'Basic',
      can_read: false,
      can_write: false
    };
  };

  const toggleLanguage = (language) => {
    setFormData(prev => {
      const currentLanguages = prev.language.map(lang => lang.language);
      const isSelected = currentLanguages.includes(language);
      let updatedLanguages = [...prev.language];

      if (isSelected) {
        updatedLanguages = updatedLanguages.filter(lang => lang.language !== language);
      } else {
        if (currentLanguages.length >= 4) return prev;
        updatedLanguages.push({
          language: language,
          speaking_level: language === "English" || language === "Arabic" ? '' : 'Basic',
          can_read: false,
          can_write: false
        });
      }

      return {
        ...prev,
        language: updatedLanguages,
        otherLanguage: language === prev.otherLanguage ? '' : prev.otherLanguage
      };
    });
    setIsSaved(false);
  };

  const updateLanguageDetails = (language, field, value) => {
    setFormData(prev => {
      const updatedLanguages = [...prev.language];
      const langIndex = updatedLanguages.findIndex(lang => lang.language === language);

      if (langIndex >= 0) {
        updatedLanguages[langIndex] = {
          ...updatedLanguages[langIndex],
          [field]: value
        };
      }

      return {
        ...prev,
        language: updatedLanguages
      };
    });
    setIsSaved(false);
  };

  const toggleItem = (field, item) => {
    setFormData(prev => {
      const currentArray = [...prev[field]];
      const itemIndex = currentArray.indexOf(item);

      if (itemIndex >= 0) {
        currentArray.splice(itemIndex, 1);
      } else {
        // Remove the limit for main_skills (defect 48)
        if ((field === 'cooking_skills' && currentArray.length >= 4 && !prev[field].includes(item)) ||
          (field === 'other_skills' && currentArray.length >= 4 && !prev[field].includes(item)) ||
          (field === 'personality' && currentArray.length >= 4 && !prev[field].includes(item))) {
          return prev;
        }
        currentArray.push(item);
      }

      return {
        ...prev,
        [field]: currentArray
      };
    });
    setIsSaved(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setIsSaved(false);
  };

  const saveData = async () => {
    setIsLoading(true);

    Swal.fire({
      title: 'Saving...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      if (formData.otherLanguage) {
        const languageExists = formData.language.some(lang =>
          lang.language === formData.otherLanguage
        );

        if (!languageExists) {
          formData.language.push({
            language: formData.otherLanguage,
            speaking_level: 'Basic',
            can_read: false,
            can_write: false
          });
        }
      }

      if (!hideCookingAndOtherSkills && formData.otherCookingSkill && !formData.cooking_skills.includes(formData.otherCookingSkill)) {
        formData.cooking_skills.push(formData.otherCookingSkill);
      }

      const dataToSend = {
        ...formData,
        height: formData.height ? `${formData.height} cm` : '',
        weight: formData.weight ? `${formData.weight} kg` : '',
        main_skills: formData.main_skills.filter(Boolean),
        cooking_skills: hideCookingAndOtherSkills ? [] : formData.cooking_skills.filter(Boolean),
        other_skills: hideCookingAndOtherSkills ? [] : formData.other_skills.filter(Boolean),
        personality: formData.personality.filter(Boolean)
      };

      const response = await fetch(`${BaseUrl}/api/job-seeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || result.message || 'Failed to save data');
      }

      await Swal.fire({
        title: 'Success!',
        text: 'Your skills information has been saved successfully.',
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#3085d6',
      });

      setIsSaved(true);
      return result;
    } catch (err) {
      console.error('Error saving data:', err);

      await Swal.fire({
        title: 'Error!',
        text: err.message || 'Failed to save data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });

      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormData = async () => {
    if (formData.language.length === 0) {
      await Swal.fire({
        title: 'Validation Error',
        text: 'Please select at least one language',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return false;
    }

    // if (!formData.height) {
    //   await Swal.fire({
    //     title: 'Validation Error',
    //     text: 'Please select your height',
    //     icon: 'error',
    //     confirmButtonText: 'OK',
    //     confirmButtonColor: '#d33',
    //   });
    //   return false;
    // }

    // if (!formData.weight) {
    //   await Swal.fire({
    //     title: 'Validation Error',
    //     text: 'Please select your weight',
    //     icon: 'error',
    //     confirmButtonText: 'OK',
    //     confirmButtonColor: '#d33',
    //   });
    //   return false;
    // }

    // main_skills is optional

    if (formData.personality.length === 0) {
      await Swal.fire({
        title: 'Validation Error',
        text: 'Please select at least one personality trait',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return false;
    }

    if (formData.language.some(lang => lang.language === "English")) {
      const englishData = formData.language.find(lang => lang.language === "English");
      if (!englishData.speaking_level) {
        await Swal.fire({
          title: 'Validation Error',
          text: 'Please select English speaking level',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    if (formData.language.some(lang => lang.language === "Arabic")) {
      const arabicData = formData.language.find(lang => lang.language === "Arabic");
      if (!arabicData.speaking_level) {
        await Swal.fire({
          title: 'Validation Error',
          text: 'Please select Arabic speaking level',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
        return false;
      }
    }

    return true;
  };

  const handleSave = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleSaveNext = async () => {
    const isValid = await validateFormData();
    if (!isValid) return;

    try {
      await saveData();

      // Scroll to top and then navigate after a small delay
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant' // Use 'instant' for immediate scroll
      });

      // Small delay to ensure scroll happens
      setTimeout(() => {
        navigate('/previous', { state: { userId, current_country } });
      }, 100);
    } catch (err) {
      // Error already handled in saveData
    }
  };

  const handleBack = () => {
    navigate('/preference', { state: { userId } });
  };

  const renderLanguageButtons = () => {
    return generalLanguagesMain.map((language, index) => {
      const isSelected = formData.language.some(lang => lang.language === language);
      return (
        <Col xs={6} md={3} key={index}>
          <Button
            className={`language-btn w-100 ${isSelected ? "selected" : ""}`}
            onClick={() => toggleLanguage(language)}
            disabled={
              formData.language.length >= 4 && !isSelected
            }
          >
            {language}
          </Button>
        </Col>
      );
    });
  };

  const renderLanguageLevelButtons = (language, levels) => {
    const langData = getLanguageDetails(language);
    return levels.map((level, index) => (
      <Col xs={6} md={3} key={index}>
        <Button
          className={`language-btn w-100 ${langData.speaking_level === level ? "selected" : ""}`}
          onClick={() => updateLanguageDetails(language, 'speaking_level', level)}
        >
          {level}
        </Button>
      </Col>
    ));
  };

  const renderLiteracyButtons = (language) => {
    const langData = getLanguageDetails(language);
    return (
      <>
        <Col xs={6} md={3}>
          <Button
            className={`language-btn w-100 ${langData.can_read ? "selected" : ""}`}
            onClick={() => updateLanguageDetails(language, 'can_read', true)}
          >
            Read
          </Button>
        </Col>
        <Col xs={6} md={3}>
          <Button
            className={`language-btn w-100 ${!langData.can_read ? "selected" : ""}`}
            onClick={() => updateLanguageDetails(language, 'can_read', false)}
          >
            No Read
          </Button>
        </Col>
        <Col xs={6} md={3}>
          <Button
            className={`language-btn w-100 ${langData.can_write ? "selected" : ""}`}
            onClick={() => updateLanguageDetails(language, 'can_write', true)}
          >
            Write
          </Button>
        </Col>
        <Col xs={6} md={3}>
          <Button
            className={`language-btn w-100 ${!langData.can_write ? "selected" : ""}`}
            onClick={() => updateLanguageDetails(language, 'can_write', false)}
          >
            No Write
          </Button>
        </Col>
      </>
    );
  };

  const renderSkillButtons = (items, field, maxButtons = 4) => {
    // Show first 'maxButtons' items as buttons
    const buttonItems = items.slice(0, maxButtons);
    const dropdownItems = items.slice(maxButtons);

    return (
      <>
        {/* Render buttons for first items */}
        {buttonItems.map((item, index) => (
          <Col xs={6} md={3} key={`${field}-btn-${index}`}>
            <Button
              className={`language-btn w-100 ${formData[field].includes(item) ? "selected" : ""}`}
              onClick={() => toggleItem(field, item)}
              disabled={
                (field === 'cooking_skills' && formData[field].length >= 4 && !formData[field].includes(item)) ||
                (field === 'other_skills' && formData[field].length >= 4 && !formData[field].includes(item)) ||
                (field === 'personality' && formData[field].length >= 4 && !formData[field].includes(item))
                // Removed main_skills limit (defect 48)
              }
            >
              {item}
            </Button>
          </Col>
        ))}

        {/* Render dropdown for remaining items */}
        {/* {dropdownItems.length > 0 && (
        <Col xs={12} md={12}>
          <CustomDropdown
            title={`Select other ${field.replace('_', ' ')}`}
            field={field}
            options={dropdownItems}
            isMultiSelect={true}
            currentSelections={formData[field]}
            menuClassName={`${field}-dropdown`}
          />
        </Col>
      )} */}
      </>
    );
  };

  return (
    <>
      <Navbar />
      <div className="skills-wrapper" style={{ marginTop: "84px" }}>
        <Container className="mt-4 px-4 pb-5">
          <Card className="shadow border-0 skills-card">
            <Card.Header className="skills-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-person-badge me-2"></i>
                My Skills
              </h2>
            </Card.Header>
            <Card.Body className="skills-body">
              <h4 className="mb-2 fw-semibold text-dark">
                <div className="d-flex flex-row align-items-start align-items-md-center">
                  <div>
                    Languages <span className="text-danger ms-1">*</span>
                  </div>
                  <p className="fw-semibold language-note ms-0 ms-md-3 mb-0 mt-2 mt-md-0">
                    (You can select maximum 4 languages)
                  </p>
                </div>
              </h4>

              <Row className="g-3 mb-3">
                {renderLanguageButtons()}
              </Row>

              {/* Languages Additional Options Dropdown */}
              {/* <div className="mt-3 mb-4">
                <CustomDropdown
                  title="Select other language if any"
                  field="language_dropdown"
                  options={generalLanguagesAdditional}
                  selectedValue=""
                  onSelect={(field, value) => {
                    if (value && !formData.language.some(lang => lang.language === value)) {
                      toggleLanguage(value);
                    }
                  }}
                  isMultiSelect={true}
                  currentSelections={formData.language.map(lang => lang.language)}
                  menuClassName="personalinfo-nationality-menu"
                />
              </div> */}

              {/* Other Language Dropdown */}
              <div className="mb-4">
                <CustomDropdown
                  title="Select other language if any"
                  field="otherLanguage"
                  options={otherLanguages}
                  selectedValue={formData.otherLanguage}
                  onSelect={handleChange}
                  menuClassName="personalinfo-nationality-menu"
                />
              </div>

              {formData.language.some(lang => lang.language === "English") && (
                <>
                  <h4 className="mb-2 fw-semibold text-dark">
                    English Language <span className="text-danger">*</span>
                  </h4>
                  <Row className="g-3 mb-3">
                    {renderLanguageLevelButtons("English", englishLevels)}
                  </Row>
                  <h4 className="mb-2 fw-semibold text-dark">Reading and writing skills</h4>
                  <Row className="g-3 mb-4">
                    {renderLiteracyButtons("English")}
                  </Row>
                </>
              )}

              {formData.language.some(lang => lang.language === "Arabic") && (
                <>
                  <h4 className="mb-2 fw-semibold text-dark">
                    Arabic Language <span className="text-danger">*</span>
                  </h4>
                  <Row className="g-3 mb-3">
                    {renderLanguageLevelButtons("Arabic", englishLevels)}
                  </Row>
                  <h4 className="mb-2 fw-semibold text-dark">Reading and writing skills</h4>
                  <Row className="g-3 mb-4">
                    {renderLiteracyButtons("Arabic")}
                  </Row>
                </>
              )}

              <h4 className="mb-2 fw-semibold text-dark">
                Height <span className="text-danger"></span>
              </h4>
              <CustomDropdown
                title="Select your Height"
                field="height"
                options={heightOptions}
                selectedValue={formData.height}
                onSelect={handleChange}
                required={true}
                menuClassName="personalinfo-nationality-menu"
              />

              <h4 className="mb-2 fw-semibold text-dark">
                Weight <span className="text-danger"></span>
              </h4>
              <CustomDropdown
                title="Select your Weight"
                field="weight"
                options={weightOptions}
                selectedValue={formData.weight}
                onSelect={handleChange}
                required={true}
                menuClassName="personalinfo-nationality-menu"
              />

              {/* Defect 47: Skin color not mandatory and renamed */}
              <h4 className="mb-2 fw-semibold text-dark">
                Skin Color
              </h4>
              <Row className="g-3 mb-4">
                {skinColorOptions.map((color, index) => (
                  <Col xs={6} md={3} key={index}>
                    <Button
                      className={`language-btn w-100 ${formData.color === color ? "selected" : ""}`}
                      onClick={() => setFormData(prev => ({ ...prev, color }))}
                    >
                      {color}
                    </Button>
                  </Col>
                ))}
              </Row>

              {/* Defect 48: Remove limit for main skills selection */}
              <h4 className="mb-3 fw-semibold text-dark">
                <div className="d-flex flex-row align-items-start align-items-md-center">
                  <div>
                    Main Skills <span className="text-danger ms-1">*</span>
                  </div>
                  <p className="fw-semibold language-note ms-0 ms-md-3 mb-0 mt-2 mt-md-0">
                    (You can select any number of main skills)
                  </p>
                </div>
              </h4>

              {/* Main Skills Buttons and Dropdown */}
              <Row className="g-3 mb-3">
                {/* Dynamic buttons: include user's selected job positions first */}
                {(() => {
                  const jobPositions = Array.isArray(job_position) ? job_position : (job_position ? [job_position] : []);
                  const combinedMainSkills = Array.from(new Set([...jobPositions.map(pos => pos.toString()), ...mainSkillsMain]));
                  
                  return combinedMainSkills.slice(0, 8).map((item, index) => {
                    const isDriver = job_position && Array.isArray(job_position) && job_position.some(pos => pos.toLowerCase().includes("driver"));
                    const displayItem = (isDriver && item === "Teen care") ? "Driving" : item;

                    return (
                      <Col xs={6} md={3} key={`main-skill-btn-${index}`}>
                        <Button
                          className={`language-btn w-100 ${formData.main_skills.includes(displayItem) ? "selected" : ""}`}
                          onClick={() => toggleItem('main_skills', displayItem)}
                        >
                          {displayItem}
                        </Button>
                      </Col>
                    );
                  });
                })()}

                {/* Show dropdown for remaining skills */}
                {(() => {
                  const jobPositions = Array.isArray(job_position) ? job_position : (job_position ? [job_position] : []);
                  const combinedMainSkills = Array.from(new Set([...jobPositions.map(pos => pos.toString()), ...mainSkillsMain]));
                  
                  if (combinedMainSkills.length > 8) {
                    return (
                      <Col xs={12} md={12}>
                        <CustomDropdown
                          title="Select other main skill"
                          field="main_skills"
                          options={Array.from(new Set([...combinedMainSkills.slice(8), ...mainSkillsAdditional]))}
                          isMultiSelect={true}
                          currentSelections={formData.main_skills}
                          menuClassName="personalinfo-nationality-menu"
                        />
                      </Col>
                    );
                  }
                  return null;
                })()}
              </Row>

              {/* Main Skills Additional Options Dropdown */}
              {/* <div className="mb-4">
                <CustomDropdown
                  title="Select other main skill if any"
                  field="main_skills_dropdown"
                  options={mainSkillsAdditional}
                  selectedValue=""
                  onSelect={(field, value) => {
                    if (value && !formData.main_skills.includes(value)) {
                      toggleItem('main_skills', value);
                    }
                  }}
                  isMultiSelect={true}
                  currentSelections={formData.main_skills}
                  menuClassName="personalinfo-nationality-menu"
                />
              </div> */}

              {!hideCookingAndOtherSkills && (
                <>
                  {/* Defect 49: Cooking skills not mandatory */}
                  <h4 className="mb-3 fw-semibold text-dark">
                    <div className="d-flex flex-row align-items-start align-items-md-center">
                      <div>
                        Cooking Skills
                      </div>
                      <p className="fw-semibold language-note ms-0 ms-md-3 mb-0 mt-2 mt-md-0">
                        (You can select maximum 4 cooking skills)
                      </p>
                    </div>
                  </h4>

                  <Row className="g-3 mb-3">
                    {renderSkillButtons(cookingSkillsMain, "cooking_skills")}
                  </Row>

                  {/* Cooking Skills Additional Options Dropdown */}
                  {/* <div className="mb-4">
                    <CustomDropdown
                      title="Select other cooking skill if any"
                      field="cooking_skills_dropdown"
                      options={cookingSkillsAdditional}
                      selectedValue=""
                      onSelect={(field, value) => {
                        if (value && !formData.cooking_skills.includes(value)) {
                          toggleItem('cooking_skills', value);
                        }
                      }}
                      isMultiSelect={true}
                      currentSelections={formData.cooking_skills}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div> */}

                  <CustomDropdown
                    title="Select other cooking skill if any"
                    field="otherCookingSkill"
                    options={["Korean", "Peruvian", "Western", "French", "Mexican", "Turkey", "Moroccan", "Brazilian",
                      "Lebanese", "Spain", "Greece", "United States"]}
                    selectedValue={formData.otherCookingSkill}
                    onSelect={handleChange}
                    menuClassName="personalinfo-nationality-menu"
                  />
                </>
              )}

              {!hideCookingAndOtherSkills && (
                <>
                  <h4 className="mb-3 fw-semibold text-dark">Other Skills</h4>
                  <Row className="g-3 mb-3">
                    {renderSkillButtons(otherSkillsMain, "other_skills", 8)}
                  </Row>

                  {/* Other Skills Additional Options Dropdown */}
                  <div className="mb-4">
                    <CustomDropdown
                      title="Select other skill if any"
                      field="other_skills"  // This was "other_skills_dropdown" - change it to "other_skills"
                      options={otherSkillsAdditional}
                      selectedValue=""
                      onSelect={(e) => { }}  // Keep this as empty function for multi-select
                      isMultiSelect={true}
                      currentSelections={formData.other_skills}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>
                </>
              )}

              <h4 className="mb-3 fw-semibold text-dark">
                Personality <span className="text-danger">*</span>
              </h4>
              <Row className="g-3 mb-3">
                {renderSkillButtons(personalityTraitsMain, "personality", 8)}
              </Row>

              {/* Personality Additional Options Dropdown */}
              <div className="mb-4">
                <CustomDropdown
                  title="Select other personality trait"
                  field="personality"  // This was "personality_dropdown" - change it to "personality"
                  options={personalityTraitsAdditional}
                  selectedValue=""
                  onSelect={(e) => { }}  // Keep this as empty function for multi-select
                  isMultiSelect={true}
                  currentSelections={formData.personality}
                  menuClassName="personalinfo-nationality-menu"
                />
              </div>

              <div className="mt-5 d-flex justify-content-between gap-3 flex-row" style={{ width: "100%" }}>
                <button
                  type="button"
                  className="nav-btn" style={{ flex: 1 }}
                  onClick={handleBack}
                  disabled={isLoading}
                >
                  Back
                </button>
                <button
                  type="button"
                  className="nav-btn" style={{ flex: 1 }}
                  onClick={handleSaveNext}
                  disabled={isLoading}
                >
                  {isLoading ? 'Saving...' : 'Next'}
                </button>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default MySkills;
